import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Backdrop, Button, CircularProgress, Fade, FormControl, FormControlLabel, Grid, Modal, Radio, RadioGroup, Typography } from "@material-ui/core";
import { legacyApiResourceUrl } from "@ploy-lib/core";
import { FormattedMessage } from "react-intl";
const useStyles = makeStyles((theme) => createStyles({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 400
    },
    headerText: {
        marginTop: 12,
        textAlign: "center",
        marginBottom: 12
    },
    formControl: {
        marginTop: 12,
        marginBottom: 12
    },
    submitButtonContainer: {
        justifyContent: "center",
        display: "flex"
    },
    submitButton: {
        marginTop: 12,
        backgroundColor: theme.palette.secondary.main,
        marginBottom: 12
    },
    submitButtonLabel: {
        color: theme.palette.secondary.contrastText
    }
}));
/* Use this component when using
    `DployMicroWeb.addPartial({
        ...
    })`
 * in order to provide a wrapper that can pass props for handling open/closed-state
 */
export const ReasonForDecisionModalInternalWebWrapper = (props) => {
    const [open, setOpen] = useState(true);
    useEffect(() => setOpen(true), [props]);
    return _jsx(ReasonForDecisionModal, { setOpen: setOpen, open: open, ...props });
};
export const ReasonForDecisionModal = (props) => {
    const { open, setOpen, confirmDecisionWithAppActionEvent, confirmDecisionWithReason, appId, decisionMode } = props;
    const onCloseHandler = () => setOpen(false);
    const classes = useStyles();
    const [allReasons, setAllReasons] = useState([]);
    const [reasonForDecision, setReasonForDecision] = useState("");
    const handleRadioBtnChange = (event) => {
        setReasonForDecision(event.target.value);
    };
    const [loading, setLoading] = useState(true);
    const doConfirm = async (event, reason) => {
        if (confirmDecisionWithReason) {
            confirmDecisionWithReason(reason);
        }
        if (confirmDecisionWithAppActionEvent) {
            confirmDecisionWithAppActionEvent(event);
        }
    };
    useEffect(() => {
        const groupCoode = decisionMode === "cancel" ? "Cancel" : "Reject";
        fetch(legacyApiResourceUrl(`StandardTextList/GetStandardTextsFromDt?code=ReasonFor${groupCoode}Opt`)).then(async (res) => {
            setAllReasons(await res.json());
            setLoading(false);
        });
    }, [decisionMode]);
    return (_jsx(Modal, { className: classes.modal, open: open, onClose: onCloseHandler, closeAfterTransition: true, BackdropComponent: Backdrop, BackdropProps: {
            timeout: 500
        }, children: _jsx(Fade, { in: open, children: _jsx("div", { className: classes.paper, children: _jsxs(Grid, { container: true, justifyContent: "space-around", direction: "column", alignContent: "center", children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: "h5", className: classes.headerText, children: _jsx(FormattedMessage, { id: "reason-for-decision-modal.header-text", defaultMessage: "Provide a reason", description: "Header text of reason for decision modal" }) }) }), _jsx(Grid, { item: true, xs: 10, children: loading ? (_jsx(CircularProgress, { size: "large" })) : allReasons.length > 0 ? (_jsx(FormControl, { variant: "standard", className: classes.formControl, children: _jsx(RadioGroup, { value: reasonForDecision, onChange: handleRadioBtnChange, children: allReasons.map((reason) => (_jsx(FormControlLabel, { value: reason, control: _jsx(Radio, {}), label: reason }))) }) })) : (_jsx(FormattedMessage, { id: "reason-for-decision-modal.error-text", defaultMessage: "Failed to fetch reasons" })) }), _jsx(Grid, { item: true, className: classes.submitButtonContainer, children: _jsx(Button, { className: classes.submitButton, onClick: event => {
                                    setOpen(false);
                                    doConfirm(event, reasonForDecision).then(async () => {
                                        //	Update UnderWritingDTO with 'ReasonForUpdate':
                                        await fetch(legacyApiResourceUrl("UnderwritingData/UpdateReasonForDecision"), {
                                            method: "POST",
                                            headers: {
                                                Accept: "application/json",
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify({
                                                reason: reasonForDecision,
                                                applicationId: appId
                                            })
                                        });
                                    });
                                }, disabled: loading || allReasons.length === 0 || reasonForDecision === "", children: _jsx(Typography, { className: classes.submitButtonLabel, children: decisionMode === "cancel" ? (_jsx(FormattedMessage, { id: "reason-for-decision-modal.confirm-cancel-button", defaultMessage: "Cancel application", description: "Confirm cancel application text" })) : (_jsx(FormattedMessage, { id: "reason-for-decision-modal.confirm-reject-button", defaultMessage: "Reject application", description: "Confirm reject application text" })) }) }) })] }) }) }) }));
};
//# sourceMappingURL=ReasonForDecisionModal.js.map